import { Layout, Modification as ModificationComponent } from "components"
export const Modification = () => {
 return (
  <Layout>
   <ModificationComponent />
  </Layout>
 )
}
